/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ListResourceEnum = {
    Patient: 'PATIENT',
    Task: 'TASK',
    Appointment: 'APPOINTMENT',
    Therapist: 'THERAPIST',
    Communication: 'COMMUNICATION',
    TextSnippet: 'TEXT_SNIPPET'
} as const;
export type ListResourceEnum = typeof ListResourceEnum[keyof typeof ListResourceEnum];

